import React, { useEffect, useMemo, useState } from "react";
import "../styles/GraduacionesNican.css";

const graduationContext = require.context(
  "../imgs/Graduaciones",
  false,
  /\.(png|jpe?g|webp)$/i
);

const buildAlt = (fileName) =>
  fileName
    .replace(/\.(png|jpe?g|webp)$/i, "")
    .replace(/-/g, " ")
    .replace(/^\d+$/, "graduacion fundacion nican");

const graduationImages = graduationContext
  .keys()
  .sort((a, b) => {
    const cleanA = a.replace("./", "");
    const cleanB = b.replace("./", "");
    const numberA = cleanA.match(/^(\d+)\./);
    const numberB = cleanB.match(/^(\d+)\./);

    if (numberA && numberB) {
      return Number(numberA[1]) - Number(numberB[1]);
    }

    if (numberA) return -1;
    if (numberB) return 1;

    return cleanA.localeCompare(cleanB);
  })
  .map((key) => {
    const fileName = key.replace("./", "");

    return {
      src: graduationContext(key),
      alt: `${buildAlt(fileName)} en Fundacion Nican`,
      fileName,
    };
  });

function GraduacionesNican() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const images = useMemo(() => graduationImages, []);
  const visibleSlots = Math.min(10, images.length);

  useEffect(() => {
    if (isPaused || images.length <= visibleSlots) return undefined;

    const timer = window.setInterval(() => {
      setActiveIndex((current) => (current + 1) % images.length);
    }, 7200);

    return () => window.clearInterval(timer);
  }, [images.length, isPaused, visibleSlots]);

  const visibleImages = useMemo(
    () =>
      Array.from({ length: visibleSlots }, (_, index) => {
        const imageIndex = (activeIndex + index) % images.length;
        return images[imageIndex];
      }).filter(Boolean),
    [activeIndex, images, visibleSlots]
  );

  return (
    <section className="graduations-section" id="graduaciones">
      <div className="container graduations-inner">
        <div className="graduations-copy" data-aos="fade-up">
          <span>Graduaciones Nican</span>
          <h2>Lo que aprendes con las manos, nadie te lo puede quitar</h2>
          <div className="graduations-statements">
            <strong>La IA no puede poner una inyeccion.</strong>
            <strong>Nadie llama a ChatGPT para un masaje.</strong>
            <strong>Una terapia real necesita criterio, tecnica y presencia.</strong>
          </div>
          <p>
            La tecnologia puede explicar, resumir y responder. Pero cuando una
            persona necesita cuidado, rehabilitacion, alivio o acompanamiento,
            busca a alguien preparado. En Fundacion Nican celebramos cada
            graduacion porque representa una habilidad real para trabajar,
            emprender y transformar vidas.
          </p>
          <div className="graduations-proof">
            <span>Generaciones formadas</span>
            <span>Practica presencial</span>
            <span>Habilidades para trabajar</span>
          </div>
          <a href="#certificaciones">Quiero prepararme tambien</a>
        </div>

        <div
          className="graduations-collage"
          data-aos="fade-up"
          data-aos-delay="160"
          aria-label="Galeria de graduaciones de Fundacion Nican"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          {visibleImages.map((image, index) => (
            <figure
              className={`graduation-photo graduation-photo-${(index % 8) + 1}`}
              key={`${image.fileName}-${activeIndex}`}
              style={{ "--delay": `${(index % 10) * 70}ms` }}
            >
              <img src={image.src} alt={image.alt} loading="lazy" />
            </figure>
          ))}
          <div className="graduations-rotation-badge" aria-hidden="true">
            Galeria en movimiento
          </div>
        </div>
      </div>
    </section>
  );
}

export default GraduacionesNican;
